import { debugLog } from "@lululemon/auth-common";
var scripts = [];
function getScriptNode(srcIdentifier) {
    var scripts = document.getElementsByTagName("script");
    var allScripts = Array.from(scripts);
    return allScripts.find(function (script) { var _a; return ((_a = ((script === null || script === void 0 ? void 0 : script.getAttribute("src")) || "")) === null || _a === void 0 ? void 0 : _a.indexOf(srcIdentifier)) > -1; });
}
export function cleanup() {
    scripts.forEach(function (src) {
        var _a;
        var script = getScriptNode(src);
        (_a = script === null || script === void 0 ? void 0 : script.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(script);
    });
}
export function loadScript(_a) {
    var src = _a.src;
    var head = document.querySelector("head");
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    head === null || head === void 0 ? void 0 : head.appendChild(script);
}
var shapePromiseCache = null;
export function loadShapeScripts(_a) {
    var timeout = _a.timeout, assetUrl = _a.assetUrl, srcIdentifier = _a.srcIdentifier, logger = _a.logger, forceReload = _a.forceReload;
    scripts = [assetUrl, srcIdentifier];
    // Check if there's an existing promise and return
    if (shapePromiseCache) {
        debugLog({ message: "Using shapePromiseCache.", level: "debug" });
        return shapePromiseCache;
    }
    var loadingTimeout;
    var observer;
    debugLog({
        message: "Setting shapePromiseCache to new promise.",
        level: "debug"
    });
    shapePromiseCache = new Promise(function (resolve, reject) {
        var isShapeSeedLoaded = Boolean(getScriptNode(srcIdentifier));
        loadingTimeout = setTimeout(function () {
            var error = new Error("Shape Scripts did not load within ".concat(timeout, " milliseconds."));
            logger === null || logger === void 0 ? void 0 : logger.error(error, {
                tags: {
                    componentName: "shape",
                    featureName: "loadShapeScripts"
                }
            });
            reject(error);
        }, timeout);
        if (isShapeSeedLoaded && !forceReload) {
            return resolve({ cleanup: cleanup });
        }
        var moCallback = function (mutationList) {
            mutationList.forEach(function (mutation) {
                if (mutation.type === "childList") {
                    mutation.addedNodes.forEach(function (node) {
                        if (node instanceof HTMLScriptElement &&
                            node.tagName === "SCRIPT" &&
                            node.src.includes(srcIdentifier)) {
                            node.onload = function () {
                                clearTimeout(loadingTimeout);
                                observer === null || observer === void 0 ? void 0 : observer.disconnect();
                                setTimeout(function () { return resolve({ cleanup: cleanup }); }, 300); // Wait for another 300ms for Shape to be fully executed
                            };
                        }
                    });
                }
            });
        };
        observer = new MutationObserver(moCallback);
        var targetNode = document.querySelector("head");
        var isShapeLoaded = Boolean(getScriptNode(assetUrl));
        if (targetNode) {
            observer.observe(targetNode, { childList: true });
            if (forceReload) {
                cleanup();
            }
            if (!isShapeLoaded || forceReload) {
                loadScript({ src: assetUrl });
            }
        }
    });
    return shapePromiseCache.finally(function () {
        debugLog({
            message: "Resetting shapePromiseCache to null.",
            level: "debug"
        });
        clearTimeout(loadingTimeout);
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        shapePromiseCache = null;
    });
}
export default loadShapeScripts;
